import React, { useEffect, useState } from 'react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    // Check localStorage for end time
    const storedEndTime = localStorage.getItem('escalada_countdown_end');
    let endTime: number;
    if (storedEndTime) {
      endTime = parseInt(storedEndTime, 10);
      // If time passed, reset to 24h from now
      if (endTime < Date.now()) {
        endTime = Date.now() + 24 * 60 * 60 * 1000;
        localStorage.setItem('escalada_countdown_end', endTime.toString());
      }
    } else {
      endTime = Date.now() + 24 * 60 * 60 * 1000;
      localStorage.setItem('escalada_countdown_end', endTime.toString());
    }
    const interval = setInterval(() => {
      const now = Date.now();
      const distance = endTime - now;
      if (distance < 0) {
        // Reset
        const newEndTime = Date.now() + 24 * 60 * 60 * 1000;
        localStorage.setItem('escalada_countdown_end', newEndTime.toString());
        return;
      }
      const hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(distance % (1000 * 60) / 1000);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 text-2xl md:text-4xl font-bebas text-white" data-id="element-38">
      <div className="bg-darker px-3 py-2 rounded border border-gray-800 min-w-[60px] text-center" data-id="element-39">
        {formatTime(timeLeft.hours)}
      </div>
      <span className="text-orange-500" data-id="element-40">:</span>
      <div className="bg-darker px-3 py-2 rounded border border-gray-800 min-w-[60px] text-center" data-id="element-41">
        {formatTime(timeLeft.minutes)}
      </div>
      <span className="text-orange-500" data-id="element-42">:</span>
      <div className="bg-darker px-3 py-2 rounded border border-gray-800 min-w-[60px] text-center text-orange-500" data-id="element-43">
        {formatTime(timeLeft.seconds)}
      </div>
    </div>;
}